import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup
  .object({
    name: yup
      .string()
      .trim()
      .required()
      .min(1, 'Name must be at least 1 character')
      .label('Name'),
    vslz_report: yup
      .object()
      .nullable()
      .required()
      .label('Visualize Report'),
    ais_report: yup
      .object()
      .nullable()
      .label('Alairo Intelligence Summary'),
    description: yup
      .string()
      .trim()
      .nullable()
      .label('Description'),
    formats: yup.array().nullable().label('Formats'),
    height: yup.object().required().label('Height'),
  })
  .required()

const resAddReport = yupResolver(schema)

export default resAddReport
